// Permisos RBAC de Reembolsos. Ver la lista pide `retail.sale.read`; entregar va aparte.

/** Van como `string`: `PermissionKey`, generado del OpenAPI, no expone claves de dominio. */
export const REFUNDS_PERMISSIONS = {
    deliver: 'retail.refund.deliver',
} as const;
